import { ocApi } from './ocApi'

// ⚠️ Лучше вынести в .env.local
const API_USER = process.env.API_USER || 'testuser'
const API_PASS = process.env.API_PASS || 'testbtpeel748'

const basicAuth =
  'Basic ' + Buffer.from(`${API_USER}:${API_PASS}`).toString('base64')

const cartApi = ocApi.injectEndpoints({
  endpoints: (build) => ({
    addProductToCart: build.mutation({
      query: (body) => ({
        url: 'checkout/cart/add',
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
          Authorization: basicAuth,
        },
      }),
      invalidatesTags: ['cart'],
    }),

    applicationCode: build.mutation({
      query: (body) => ({
        url: 'checkout/voucher/voucher',
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
          Authorization: basicAuth,
        },
      }),
    }),

    getCountProducts: build.query({
      query: () => ({
        url: 'checkout/cart/getCountProducts',
        headers: { Authorization: basicAuth },
      }),
      providesTags: ['cart'],
    }),

    getPromotionsInfo: build.query({
      query: () => ({
        url: 'checkout/cart/getPromotionsInfo',
        headers: { Authorization: basicAuth },
      }),
    }),

    getCartInfo: build.query({
      query: () => ({
        url: 'd_quickcheckout/cart/indexJson',
        headers: { Authorization: basicAuth },
      }),
      providesTags: ['cart'],
    }),

    updateCartInfo: build.mutation({
      query: (data) => ({
        url: 'd_quickcheckout/cart/update',
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          Authorization: basicAuth,
        },
        invalidatesTags: ['cart'],
      }),
      providesTags: ['cart'],
    }),

    getPromoStatuses: build.query({
      query: () => ({
        url: 'module/d_quickcheckout/getPromotionsStatuses',
        headers: { Authorization: basicAuth },
      }),
    }),

    getPresentsProducts: build.query({
      query: () => ({
        url: 'd_quickcheckout/product_to_present/indexJson',
        headers: { Authorization: basicAuth },
      }),
      providesTags: ['PresentToProducts'],
    }),

    updatePresentsProducts: build.mutation({
      query: (data) => ({
        url: 'd_quickcheckout/product_to_present/updateProduct',
        method: 'POST',
        body: data,
        headers: { Authorization: basicAuth },
        invalidatesTags: ['PresentToProducts'],
      }),
    }),

    clearCart: build.mutation({
      query: (userInfo) => ({
        url: 'd_quickcheckout/cart/clearCart',
        method: 'POST',
        body: { userInfo },
        headers: { Authorization: basicAuth },
        invalidatesTags: ['cart'],
      }),
    }),

    getInitialSteps: build.query({
      query: () => ({
        url: 'module/d_quickcheckout/stepsInit',
        headers: { Authorization: basicAuth },
      }),
    }),

    updateArea: build.mutation({
      query: (data) => ({
        url: 'd_quickcheckout/area/update',
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          Authorization: basicAuth,
        },
      }),
    }),

    /**
     * Получение списка пунктов выдачи Яндекс Доставки
     * Бэкенд-прокси: index.php?route=module/d_quickcheckout/yandex/pickup-points/list
     */
    getYandexPickupPoints: build.query({
      query: (params = {}) => {
        const queryParams = new URLSearchParams()
        if (params.geo_id) queryParams.append('geo_id', params.geo_id)
        if (params.pickup_point_ids)
          queryParams.append('pickup_point_ids', params.pickup_point_ids)
        if (params.type) queryParams.append('type', params.type)
        if (params.payment_method)
          queryParams.append('payment_method', params.payment_method)
        if (params.available_for_dropoff !== undefined)
          queryParams.append('available_for_dropoff', params.available_for_dropoff)
        if (params.is_yandex_branded !== undefined)
          queryParams.append('is_yandex_branded', params.is_yandex_branded)
        if (params.is_not_branded_partner_station !== undefined)
          queryParams.append('is_not_branded_partner_station', params.is_not_branded_partner_station)
        if (params.payment_methods)
          queryParams.append('payment_methods', JSON.stringify(params.payment_methods))
        if (params.operator_ids)
          queryParams.append('operator_ids', JSON.stringify(params.operator_ids))
        if (params.latitude)
          queryParams.append('latitude', JSON.stringify(params.latitude))
        if (params.longitude)
          queryParams.append('longitude', JSON.stringify(params.longitude))
        if (params.pickup_services)
          queryParams.append('pickup_services', JSON.stringify(params.pickup_services))

        const url = `module/d_quickcheckout/yandex/pickup-points/list${
          queryParams.toString() ? `?${queryParams.toString()}` : ''
        }`

        return {
          url,
          method: 'POST',
          body: {},
          headers: {
            'Content-Type': 'application/json',
            Authorization: basicAuth,
          },
        }
      },
    }),
  }),
})

export const {
  useAddProductToCartMutation,
  useGetCountProductsQuery,
  useGetCartInfoQuery,
  useUpdateCartInfoMutation,
  useClearCartMutation,
  useGetInitialStepsQuery,
  useUpdateAreaMutation,
  useGetPromoStatusesQuery,
  useGetPresentsProductsQuery,
  useUpdatePresentsProductsMutation,
  useGetPromotionsInfoQuery,
  useApplicationCodeMutation,
  useGetYandexPickupPointsQuery,
} = cartApi

export default cartApi